import { createSlice } from '@reduxjs/toolkit';
import { getAllReturns } from './thunks';

export const initialStateReturns = {
  returns: {
    total: 0,
    rows: [],
    paginate: {
      current_page: 1,
      items: 0,
      pages: 1,
    },
    success: false,
  },
  loading: false,
};

const returnsSlice = createSlice({
  name: 'returns',
  initialState: initialStateReturns,
  reducers: {
    setReturns: (state: any, action: any) => {
      state.returns.rows = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllReturns.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllReturns.fulfilled, (state, action) => {
      state.returns = action.payload;
      state.returns.rows = action.payload?.returns ?? [];
      state.loading = false;
    });
  },
});

export const { setReturns } = returnsSlice.actions;

export default returnsSlice.reducer;
